/* eslint-disable import/no-cycle */
/* eslint-disable no-empty-pattern */
/* eslint-disable no-shadow */
import {
  GetterTree,
  MutationTree,
  ActionTree,
  Module
} from 'vuex';

import VehicleLevel from '@/enums/VehicleLevel';
import Derivative from '@/models/vehicle/derivative';
import IManufacturer from '@/models/vehicle/interfaces/manufacturer.d';
import IRange from '@/models/vehicle/interfaces/range.d';
import IDerivative from '@/models/vehicle/interfaces/derivative.d';
import VehicleStatusType from '@/enums/VehicleStatusType';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import Vehicle from '@/models/vehicle/vehicle';
import VehicleModuleOptions from '@/models/VehicleModuleOptions';
import VehicleType from '@/enums/VehicleType';
import ExtraData from '@/models/ExtraData';
import { pricingService } from '@/services/pricing-service';
import IModel from '@/models/vehicle/interfaces/model.d';
import VehicleState from '../states/vehicle-state';
import IVehicleState from '../states/interfaces/vehicle-state.d';
import IRootState from '../states/interfaces/index.d';

export const state: IVehicleState = new VehicleState();

export const getters: GetterTree<IVehicleState, IRootState> = {
  isRequiredBodyStyleSet: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    if (searchQuery.vehicleLevel === VehicleLevel.Range) {
      // Not needed so return true.
      return true;
    }

    if (searchQuery.bodystyles !== null && searchQuery.bodystyles.length === 1) {
      return true;
    }

    const bodyStyleNotSure: ExtraData = rootGetter['enquiryModule/extraData']
      .find((x: ExtraData) => x.keyName === 'bodyStyleNotSure');

    return !!bodyStyleNotSure;
  },
  isRequiredModelSet: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    if (searchQuery.vehicleLevel === VehicleLevel.Range) {
      // Not needed so return true.
      return true;
    }

    if (searchQuery.modelId !== null && searchQuery.modelId > 0) {
      return true;
    }

    return false;
  },
  isVehicleLevelDataSet: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    return searchQuery.manufacturerIds !== null
      && searchQuery.manufacturerIds.length > 0
      && searchQuery.rangeIds !== null
      && searchQuery.rangeIds > 0
      && (getters.isRequiredBodyStyleSet || getters.isRequiredModelSet);
  },
  isVehicleCustomisationDataSet: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    return searchQuery.fuelTypes !== null
      && searchQuery.fuelTypes.length === 1
      && searchQuery.transmissions !== null
      && searchQuery.doors !== null
      && (searchQuery.derivativeId !== null
        || searchQuery.trims !== null);
  },
  isDQVehicleCustomisationDataSet: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    const extraData: ExtraData[] = rootGetter['enquiryModule/extraData'];

    let fuelTypeNotSure = false;
    let transmissionNotSure = false;
    let engineSizeNotSure = false;

    extraData.forEach((x) => {
      if (x.keyName === 'fuelTypeNotSure') {
        fuelTypeNotSure = true;
      } else if (x.keyName === 'transmissionNotSure') {
        transmissionNotSure = true;
      } else if (x.keyName === 'engineSizeNotSure') {
        engineSizeNotSure = true;
      }
    });

    return ((searchQuery.fuelTypes !== null || fuelTypeNotSure)
      && (searchQuery.transmissions !== null || transmissionNotSure)
      && (searchQuery.engineSize !== null || engineSizeNotSure));
  },
  isDQVehicleCustomisationBDataSet: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    const extraData: ExtraData[] = rootGetter['enquiryModule/extraData'];

    let fuelTypeNotSure = false;
    let transmissionNotSure = false;
    let engineSizeNotSure = false;

    extraData.forEach((x) => {
      if (x.keyName === 'fuelTypeNotSure') {
        fuelTypeNotSure = true;
      } else if (x.keyName === 'transmissionNotSure') {
        transmissionNotSure = true;
      } else if (x.keyName === 'engineSizeNotSure') {
        engineSizeNotSure = true;
      }
    });

    return ((searchQuery.fuelTypes !== null || fuelTypeNotSure)
      && (searchQuery.transmissions !== null || transmissionNotSure)
      && (searchQuery.engineSize !== null || engineSizeNotSure)
      && searchQuery.doors !== null);
  },
  currentSelectionKey: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    let key = '';

    if (searchQuery.manufacturerIds !== null
      && searchQuery.manufacturerIds.length > 0) {
      key += searchQuery.manufacturerIds[0];
    }

    if (searchQuery.rangeIds !== null) {
      key += searchQuery.rangeIds;
    }

    if (searchQuery.modelId !== null || searchQuery.modelId > 0) {
      key += searchQuery.modelId;
    }

    if (searchQuery.bodystyles !== null
      && searchQuery.bodystyles.length > 0) {
      key += searchQuery.bodystyles[0];
    }

    if (searchQuery.fuelTypes !== null
      && searchQuery.fuelTypes.length > 0) {
      key += searchQuery.fuelTypes[0];
    }

    if (searchQuery.transmissions !== null) {
      key += searchQuery.transmissions;
    }

    if (searchQuery.doors !== null) {
      key += searchQuery.doors;
    }

    if (searchQuery.trims !== null) {
      key += searchQuery.trims;
    }

    if (searchQuery.derivativeId !== null) {
      key += searchQuery.derivativeId;
    }

    if (searchQuery.engineSize !== null) {
      key += searchQuery.engineSize;
    } else {
      const engineSizeNotSure = rootGetter['enquiryModule/extraData']
        .find((x: ExtraData) => x.keyName === 'engineSizeNotSure');

      key += `${engineSizeNotSure ? 'true' : 'false'}`;
    }

    return key;
  },
  averagePriceAvailable: (state, getters) => getters.averagePrices[1] > 0,
  averagePrices: (state, getters, rootState, rootGetter) => {
    let derivatives: IDerivative[] = [];

    if (rootGetter[`vehicleSearchModule${state.moduleKey}/derivatives`]
      && rootGetter[`vehicleSearchModule${state.moduleKey}/derivatives`].length > 0) {
      // eslint-disable-next-line prefer-destructuring
      derivatives = rootGetter[`vehicleSearchModule${state.moduleKey}/derivatives`];
    }

    if (derivatives !== null) {
      let averageMRP = 0;
      let averagePrice = 0;

      const extraData: ExtraData[] = rootGetter['enquiryModule/extraData'];
      const extraDataAveragePrice = extraData.find((x) => x.keyName === 'averagePrice');
      const extraDataMrp = extraData.find((x) => x.keyName === 'retailPrice');
      const enquiryId: number = rootGetter['postEnquiryModule/getEnquiryId'];

      if (enquiryId > 0 && extraDataMrp) {
        averageMRP = parseInt(extraDataMrp.keyValue, 10);

        if (extraDataAveragePrice) {
          averagePrice = parseInt(extraDataAveragePrice.keyValue, 10);
        }

        if (averageMRP > averagePrice) {
          return [averageMRP, averagePrice];
        }

        return [averageMRP, 0];
      }

      const minPrice = 1000;
      const derivative = state.currentDerivative as Derivative;
      const trimNotSure = extraData.find((x: ExtraData) => x.keyName === 'trimNotSure');
      const trimDerivatives = derivative && !trimNotSure ? derivatives.filter((x) => x.trimName === derivative.trimName) : derivatives;

      if (trimDerivatives.length > 0) {
        const lowestMrpArr = trimDerivatives.filter((x) => x.mrp > minPrice);
        const lowestMrp = lowestMrpArr.length > 0 ? lowestMrpArr.reduce((acc: IDerivative, curr: IDerivative) => ((acc.mrp < curr.mrp) ? acc : curr)).mrp : 0;

        const lowestAveragePriceArr = trimDerivatives.filter((x) => x.averagePrice > minPrice);
        const lowestAveragePrice = lowestAveragePriceArr.length > 0 ? lowestAveragePriceArr.reduce((acc: IDerivative, curr: IDerivative) => ((acc.averagePrice < curr.averagePrice) ? acc : curr)).averagePrice : 0;

        if (lowestMrp > minPrice) {
          averageMRP = Math.floor(lowestMrp);
        }

        if (lowestAveragePrice > minPrice) {
          averagePrice = Math.floor(lowestAveragePrice);
        }
      }

      if (averageMRP > averagePrice) {
        return [averageMRP, averagePrice];
      }

      if (averageMRP > minPrice) {
        return [averageMRP, 0];
      }
    }

    return [0, 0];
  },
  averagePercentSavingAvailable: (state) => state.averagePercentSaving > 0,
  averagePercentSaving: (state) => state.averagePercentSaving,
  currentBodyStyle: (state, getters, rootState, rootGetter) => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];
    if (searchQuery.bodystyles !== null) {
      const bodyStyle = searchQuery.bodystyles[0];
      return rootState[`vehicleSearchModule${state.moduleKey}`].results.items.find((x) => x.bodystyles.includes(bodyStyle));
    }

    const derivative: IDerivative | null = rootState[`vehicleSearchModule${state.moduleKey}`].results.items.find((x: IDerivative) => x.modelId === searchQuery.modelId);

    if (derivative) {
      return derivative;
    }

    try {
      const modelSearchQuery: string | undefined = window.location.href.split(/[?&]/).find((x) => x.startsWith('tlaModelId'));
      if (modelSearchQuery) {
        const modelId: number = parseInt(modelSearchQuery.split('=')[1], 10);
        return rootState[`vehicleSearchModule${state.moduleKey}`].results.items.find((x) => x.modelId === modelId);
      }
    } catch (error) {
      window.console.error(
        'Failed to convert Model Id from query.',
        { error }
      );
    }

    return null;
  },
  currentManufacturer: (state): IManufacturer | null => state.currentManufacturer,
  currentRange: (state): IRange | null => state.currentRange,
  currentDerivative: (state): IDerivative | null => state.currentDerivative,
  currentModel: (state, getters, rootState, rootGetter): IModel | null => {
    const searchQuery = rootGetter[`searchQueryModule${state.moduleKey}/searchQuery`];

    if (searchQuery.modelId !== null || searchQuery.modelId > 0) {
      const derivative: IDerivative | null = rootState[`vehicleSearchModule${state.moduleKey}`].results.items.find((x: IDerivative) => x.modelId === searchQuery.modelId);
      return derivative ? { modelId: derivative.modelId, modelName: derivative.modelName } : null;
    }

    return null;
  },
  isVehicleDataSet: (state): boolean => state.isVehicleDataSet,
  currentVehicle: (state): IVehicle | null => {
    if (state.currentRange === null) {
      return null;
    }

    const vehicle = new Vehicle();
    vehicle.vehicleType = state.vehicleType;
    vehicle.vehicleLevel = state.vehicleLevel;
    vehicle.vehicleStatusType = state.vehicleStatusType;
    vehicle.manufacturerId = state.currentRange.manufacturerId;
    vehicle.rangeId = state.currentRange.rangeId;

    if (state.currentDerivative !== null && state.currentDerivative.derivativeId > 0) {
      vehicle.modelId = state.currentDerivative.modelId;
      vehicle.modelName = state.currentDerivative.modelName;
      [vehicle.bodyStyleName] = state.currentDerivative.bodystyles;
      vehicle.derivativeId = state.currentDerivative.derivativeId;
    } else {
      try {
        const modelSearchQuery: string | undefined = window.location.href.split(/[?&]/).find((x) => x.startsWith('tlaModelId'));
        if (modelSearchQuery) {
          vehicle.modelId = parseInt(modelSearchQuery.split('=')[1], 10);
          vehicle.vehicleLevel = VehicleLevel.Model;
        }
      } catch (error) {
        window.console.error(
          'Failed to convert Model Id from query.',
          { error }
        );
      }
    }

    return vehicle;
  },
  currentManufacturerId: (state, getters): number => {
    if (getters.currentManufacturer !== null
      && getters.currentManufacturer.manufacturerId > 0) {
      return getters.currentManufacturer.manufacturerId;
    }

    return 0;
  }
};

export const mutations: MutationTree<IVehicleState> = {
  setVehicleLevel: (state, vehicleLevel: VehicleLevel) => {
    state.vehicleLevel = vehicleLevel;
  },
  setVehicleType: (state, vehicleType: VehicleType) => {
    state.vehicleType = vehicleType;
  },
  setManufacturer: (state: VehicleState, manufacturer: IManufacturer | null) => {
    state.currentManufacturer = manufacturer;
  },
  setRange: (state: VehicleState, range: IRange | null) => {
    state.currentRange = range;
  },
  setDerivative: (state: VehicleState, derivative: IDerivative | null) => {
    state.currentDerivative = derivative;
  },
  setVehicleDataSet: (state: VehicleState, isVehicleDataSet: boolean) => {
    state.isVehicleDataSet = isVehicleDataSet;
  },
  setVehicleStatusType: (state: VehicleState, vehicleStatusType: VehicleStatusType) => {
    state.vehicleStatusType = vehicleStatusType;
  },
  setAveragePercentSaving: (state: VehicleState, averagePercentSaving: number) => {
    state.averagePercentSaving = averagePercentSaving;
  }
};

export const actions: ActionTree<IVehicleState, IRootState> = {
  submitVehicleLevel({ commit }, vehicleLevel: VehicleLevel) {
    if (vehicleLevel) {
      commit('setVehicleLevel', vehicleLevel);
    }
  },
  submitVehicleType({ commit }, vehicleType: VehicleType) {
    commit('setVehicleType', vehicleType);
  },
  async submitManufacturer({
    state, commit, dispatch
  }, manufacturer: IManufacturer | null) {
    await dispatch('submitResetVehicleCustomisationData');
    const manufacturerId = manufacturer && manufacturer.manufacturerId > 0 ? [manufacturer.manufacturerId] : null;
    dispatch(`searchQueryModule${state.moduleKey}/submitManufacturerIds`, manufacturerId, { root: true });

    commit('setManufacturer', manufacturer);
    dispatch('submitRange', null);
    dispatch(`vehicleSearchModule${state.moduleKey}/updateRanges`, null, { root: true });
  },
  async submitRange(
    {
      state, commit, dispatch
    },
    range: IRange | null
  ) {
    let rangeId: number | null = null;
    if (range !== null && range.rangeId > 0) {
      ({ rangeId } = range);
    }
    dispatch('submitBodystyle', null);
    dispatch(`searchQueryModule${state.moduleKey}/submitRangeId`, rangeId, { root: true });
    commit('setRange', range);
    dispatch('submitDerivative', null);
  },
  submitDerivative(
    {
      state, commit, dispatch, getters
    },
    derivative: IDerivative | null
  ) {
    let derivativeId: number | null = null;
    dispatch(`searchQueryModule${state.moduleKey}/submitDerivativeId`, derivativeId, { root: true });
    commit('setDerivative', derivative);

    if (derivative !== null && derivative.derivativeId > 0) {
      ({ derivativeId } = derivative);

      if (getters.averagePrices[1] > 0) {
        dispatch('enquiryModule/submitExtraData', new ExtraData('averagePrice', getters.averagePrices[1].toString()), { root: true });
      }

      if (getters.averagePrices[0] > 0) {
        dispatch('enquiryModule/submitExtraData', new ExtraData('retailPrice', getters.averagePrices[0].toString()), { root: true });
      }
    }
  },
  submitModelId({ state, dispatch }, modelId: number | null) {
    dispatch(`searchQueryModule${state.moduleKey}/submitModelId`, modelId, { root: true });
  },
  submitBodystyle({ state, dispatch, rootState }, bodyStyle: string[] | null) {
    if (rootState.initialSettingsModule.initialSettings !== null
      && rootState.initialSettingsModule.initialSettings.bodystyles !== null
      && rootState.initialSettingsModule.initialSettings.bodystyles.length === 1) {
      dispatch(`searchQueryModule${state.moduleKey}/submitBodystyles`, rootState.initialSettingsModule.initialSettings.bodystyles, { root: true });
    } else {
      dispatch(`searchQueryModule${state.moduleKey}/submitBodystyles`, bodyStyle, { root: true });
    }
  },
  submitFuelTypes({ state, dispatch, rootState }, fuelType: string[] | null) {
    if (fuelType === null
      && rootState.initialSettingsModule.initialSettings !== null
      && rootState.initialSettingsModule.initialSettings.fuelTypes !== null
      && rootState.initialSettingsModule.initialSettings.fuelTypes.length > 0) {
      dispatch(`searchQueryModule${state.moduleKey}/submitFuelTypes`, rootState.initialSettingsModule.initialSettings.fuelTypes, { root: true });
    } else {
      dispatch(`searchQueryModule${state.moduleKey}/submitFuelTypes`, fuelType, { root: true });
    }
  },
  submitTransmission({ state, dispatch }, transmission: string | null) {
    dispatch(`searchQueryModule${state.moduleKey}/submitTransmission`, transmission, { root: true });
  },
  submitDoors({ state, dispatch }, doors: number | null) {
    dispatch(`searchQueryModule${state.moduleKey}/submitDoors`, doors, { root: true });
  },
  submitTrims({ state, dispatch }, trim: string[] | null) {
    dispatch(`searchQueryModule${state.moduleKey}/submitTrims`, trim, { root: true });
  },
  async submitResetVehicleCustomisationData({ state, dispatch }) {
    await dispatch('submitFuelTypes', null);
    await dispatch(`searchQueryModule${state.moduleKey}/submitTransmission`, null, { root: true });
    await dispatch(`searchQueryModule${state.moduleKey}/submitDoors`, null, { root: true });
    await dispatch(`searchQueryModule${state.moduleKey}/submitEngineSize`, null, { root: true });
    await dispatch(`searchQueryModule${state.moduleKey}/submitBasicColour`, null, { root: true });
    await dispatch(`searchQueryModule${state.moduleKey}/submitSpecificColour`, null, { root: true });
    await dispatch(`searchQueryModule${state.moduleKey}/submitDerivativeId`, null, { root: true });
    await dispatch(`searchQueryModule${state.moduleKey}/submitTrims`, null, { root: true });
  },
  submitVehicleDataSet({ commit }, isVehicleDataSet: boolean) {
    commit('setVehicleDataSet', isVehicleDataSet);
  },
  submitEngineSize({ state, dispatch }, engineSize: number | null) {
    dispatch(`searchQueryModule${state.moduleKey}/submitEngineSize`, engineSize, { root: true });
  },
  submitBasicColour({ state, dispatch }, basicColour: string | null) {
    dispatch(`searchQueryModule${state.moduleKey}/submitBasicColour`, basicColour, { root: true });
  },
  submitSpecificColour({ state, dispatch }, specificColour: string | null) {
    dispatch(`searchQueryModule${state.moduleKey}/submitSpecificColour`, specificColour, { root: true });
  },
  submitAveragePercentSaving({ commit }) {
    commit('setAveragePercentSaving', pricingService.calculateAverageSavingsPercentage());
  },
  createNewModuleInstance({ }, options: VehicleModuleOptions) {
    const newStateInstance: IVehicleState = new VehicleState();
    newStateInstance.moduleKey = options.moduleKey;
    newStateInstance.vehicleType = options.vehicleType;
    newStateInstance.vehicleLevel = options.vehicleLevel;
    newStateInstance.vehicleStatusType = options.vehicleStatusType;

    this.registerModule(`vehicleModule${options.moduleKey}`, {
      state: newStateInstance,
      getters,
      actions,
      mutations,
      namespaced: true
    });
  }
};

export const vehicleModule: Module<IVehicleState, IRootState> = {
  state, getters, mutations, actions, namespaced: true
};
